import { useTranslation } from 'react-i18next';

import { Flex, Text, spaces } from '@electricjs/arc';

import { Product } from '@/types/products';
import formatCurrency from '@/helpers/formatCurrency';

type InternationalProductSelectOptionProps = {
  data: Product;
  isSelected: boolean;
  isDisabled: boolean;
};

export const InternationalProductSelectOption = ({
  data,
  isSelected,
  isDisabled,
}: InternationalProductSelectOptionProps) => {
  const { t } = useTranslation('storefront');

  const showDisabled = isSelected || isDisabled;

  return (
    <Flex
      width="100%"
      padding={`${spaces.space_xs} ${spaces.space_2xs}`}
      justifyContent="space-between"
      alignItems="center"
      columnGap={spaces.space_s}>
      {/* Left column */}
      <Text
        variant="label-large"
        intent={showDisabled ? 'disabled' : undefined}>
        {data.name}
      </Text>

      {/* Right column */}
      <Flex vertical alignItems="flex-end">
        <Text
          variant="body"
          textAlign="right"
          intent={showDisabled ? 'disabled' : undefined}>
          {t('international.productOption.estimatedPrice')}{' '}
        </Text>
        <Text
          variant="label-large"
          intent={showDisabled ? 'disabled' : undefined}>
          {data.price === undefined
            ? t('international.productOption.priceOnRequest')
            : formatCurrency(data.price, data.currencyCode)}
        </Text>
      </Flex>
    </Flex>
  );
};
